import { uniqueId } from 'lodash';
import { Temp } from './Temp';

export interface SimpleTag {
  id: number;
  name: string;
  description?: string | null;
  color?: string;
}

export enum TagDifficultyEnum {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
}
export type LevelUnion = 1 | 2 | 3 | 4 | 5;
export default class Tag {
  id!: number;
  description!: string | null;
  areaId!: number;
  difficulty!: TagDifficultyEnum;
  level!: LevelUnion;

  constructor(tag: Partial<Tag>) {
    Object.assign(this, tag);
  }
}

export const implementsOfTag = (obj: any): obj is Tag => {
  if (!obj) return false;
  return (
    'id' in obj &&
    'name' in obj &&
    'description' in obj &&
    'areaId' in obj &&
    'difficulty' in obj &&
    'level' in obj
  );
};

export class TagWithName extends Tag implements Temp {
  name!: string;
  tempId?: string = uniqueId();

  constructor(tag: Partial<TagWithName>) {
    super(tag);
    Object.assign(this, tag);
  }
}
